import React, { useEffect, useState } from "react";
import RightSectionEM from "../educationMamaComponents/RightSectionEM/RightSectionEM";
import Logo from "../../../src/public/images/logo.png";
import HeaderComponent from "./HeaderComponent";
import "./invoiceDesign.scss";
import moment from "moment";
import CheckoutForm from "../educationMamaComponents/StudentDetails/CheckoutForm";

const UnpaidInvoiceDesign = ({ invoiceDetails }) => {
  console.log("Aggregate Invoice", invoiceDetails);
  const [checkedInvoices, setcheckedInvoices] = useState([]);

  const calculateTotalAmount = () => {
    return checkedInvoices.reduce((total, invoice) => {
      return invoice.checked ? total + invoice.amount : total;
    }, 0);
  };

  useEffect(() => {
    if (invoiceDetails) {
      const data = invoiceDetails.map((item) => {
        return {
          id: item?.id,
          amount: item?.amount_payable,
          courseName: item?.lm_course?.course_name,
          releaseDate: item?.release_date,
          teacherName:
            item?.lm_program?.lm_assign_program?.[0]?.teacher_nu_users
              ?.user_name,
          checked: true,
          currency: item?.lm_course?.course_country_price
            ? item?.lm_course?.course_country_price
            : "PKR",
        };
      });
      setcheckedInvoices(data);
    }
  }, []);

  const printTheInvoice = () => {
    let printContents = document.getElementById("printablediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const handleToggleCheckbox = (id) => {
    setcheckedInvoices((prevInvoices) =>
      prevInvoices.map((invoice) =>
        invoice.id === id ? { ...invoice, checked: !invoice.checked } : invoice
      )
    );
  };

  console.log("Checked Invoices", checkedInvoices);

  return (
    <div className="FeedComponent FeedComponentForTeacher">
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row" id="printablediv">
            <div className="col-md-12">
              <div className="container">
                <div className="row">
                  {/* <div className="col-md-12 p-3" style={{ background: "#004AAD" }}>
                    <div className="d-flex justify-content-between">
                      <img src={Logo} />
                      <h3 className="text-light my-auto">INVOICE</h3>
                    </div>
                  </div> */}
                  <div className="container">
                    <div className="row smallLabelForMobile">
                      {checkedInvoices && (
                        <>
                          <div className="col-md-12 d-flex justify-content-between mt-4">
                            <img src={Logo} />
                            <div className="text-right">
                              <label>
                                Invoice No :{" "}
                                {Math.floor(1000 + Math.random() * 9000)}
                              </label>{" "}
                              <br />
                            </div>
                            {/* <label>Invoice Date :</label> <br /> */}
                          </div>
                          <div className="col-md-12 text-right">
                            <div className="d-flex justify-content-between">
                              <div style={{ color: "#004AAD" }}>
                                <h3></h3>
                              </div>

                              <div className="text-right">
                                {/* <label>Due Date : </label> <br /> */}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-md-12">
                        <table className="table">
                          <thead>
                            <tr className="tableForInvoice">
                              <th scope="col">COURSES</th>
                              {/* <th scope="col">PERIOD</th> */}
                              {/* <th className="text-center" scope="col">
                                LATE FEE
                              </th> */}
                              <th className="text-center" scope="col">
                                TOTAL
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {checkedInvoices &&
                              checkedInvoices?.map((item) => (
                                <tr>
                                  <td>
                                    <div>
                                      <label className="boldLabel m-0">
                                        {item?.courseName}{" "}
                                      </label>
                                      <br />
                                      <label className="m-0">
                                        {moment(item?.releaseDate).format(
                                          "Do MMMM YYYY"
                                        )}
                                      </label>
                                    </div>

                                    {item?.teacherName && (
                                      <label
                                        className="m-auto"
                                        style={{ fontSize: 12 }}
                                      >
                                        By&nbsp;
                                        {item?.teacherName}
                                      </label>
                                    )}
                                  </td>
                                  {/* <td>
                                <label className="boldLabel">Jan-Feb</label>
                              </td> */}
                                  {/* <td className="text-center">
                                    <label className="text-muted" style={{ fontSize: 12 }}>
                                      None if paid by {moment(item?.due_date).format("Do MMM YY")}
                                    </label>
                                  </td> */}
                                  <td className="text-center">
                                    <label className="boldLabel">
                                      {item?.currency}{" "}
                                      {item?.amount &&
                                        Number(item.amount).toLocaleString()}
                                    </label>
                                    <input
                                      type="checkbox"
                                      className="ml-4"
                                      checked={item?.checked}
                                      onChange={(e) =>
                                        handleToggleCheckbox(item?.id)
                                      }
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="col-md-12 singleLine"></div>
                      </div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4 mt-5">
                        <div className="d-flex justify-content-between">
                          <label className="boldLabel">Sub Total:</label>
                          <label className="boldLabel text-muted">
                            PKR{" "}
                            {Number(calculateTotalAmount()).toLocaleString()}{" "}
                          </label>
                        </div>
                        <div className="d-flex justify-content-between">
                          <label className="boldLabel">Tax: </label>
                          <label className="boldLabel text-muted">PKR 0</label>
                        </div>
                      </div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4 singleLine mt-3"></div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4">
                        <div className="d-flex justify-content-between mt-2">
                          <label className="boldLabel">Total: </label>
                          <label className="boldLabel">
                            PKR{" "}
                            {Number(calculateTotalAmount()).toLocaleString()}{" "}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-8"></div>
                      {/* <div className="col-md-4">
                        <button className="btn btn-success btn btn-block mt-4 font-weight-bold">
                          PAY NOW
                        </button>
                      </div> */}
                    </div>
                  </div>

                  <div
                    className="col-md-12 p-3"
                    style={{ background: "#E9EFF8" }}
                  >
                    <h5 style={{ color: "#004AAD" }}>Terms & Conditions</h5>
                    <p style={{ color: "#004AAD" }}>
                      The monthly fee is non-refundable even if the student
                      discontinues before completing the month All fees should
                      be paid before the due date to avoid an additional late
                      fee (5% of the total invoice amount) will be applicable
                    </p>
                  </div>
                  <div className="col-md-12 p-2 d-flex justify-content-center">
                    <button
                      className={
                        calculateTotalAmount() !== 0
                          ? "btn btn-primary btn-sm mt-3"
                          : "btn btn-primary btn-sm mt-3 disabled"
                      }
                      // onClick={() => printTheInvoice()}
                      data-toggle="modal"
                      data-target={
                        calculateTotalAmount() !== 0 ? "#myModal" : null
                      }
                    >
                      Pay Now - PKR{" "}
                      {Number(calculateTotalAmount()).toLocaleString()}
                    </button>
                  </div>
                  {/* <div className="text-right p-2">
                    <button
                      className="btn btn-primary btn-sm text-right"
                      onClick={() => printTheInvoice()}
                    >
                      Download Invoice
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="classStart">
        <div className="modalForZoomLink">
          <div class="modal fade" tabindex="-1" role="dialog" id="myModal">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <CheckoutForm
                    invoiceData={checkedInvoices}
                    price={calculateTotalAmount()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnpaidInvoiceDesign;
